import React from 'react';
import styled from 'styled-components';
import DefaultInput from 'components/input/DefaultInput';
import DefaultTextArea from 'components/input/DefaultTextArea';
import ImageSelect from 'components/select/ImageSelect';
/**
 * * 작품 관리 - DLC 다국어 폼 컴포넌트
 */

const DLCLocalForm = ({ langList, setLangList, dlcBannerImgDropList }) => {
  const handleInputChange = (e) => {
    const { id, value, name } = e.target;
    setLangList(
      langList?.map((v) => (v.lang === id ? { ...v, [name]: value } : v)),
    );
  };
  const handleImgChange = (value, data) => {
    const { name, title } = data;
    setLangList(
      langList?.map((v) => (v.lang === title ? { ...v, [name]: value } : v)),
    );
  };

  return (
    <>
      {langList?.map((v) => (
        <Container>
          <DefaultInput
            title='제목'
            name='dlc_title'
            id={`${v.lang}`}
            codeName={v.code_name ? v.code_name : ''}
            value={v.dlc_title}
            onChange={handleInputChange}
            maxLength={60}
            localizing
          />
          <DefaultTextArea
            title='요약'
            id={`${v.lang}`}
            name='dlc_summary'
            value={v.dlc_summary}
            onChange={handleInputChange}
            maxLength={500}
          />
          <ImageSelect
            labelTitle='배너'
            name='banner_id'
            title={v.lang}
            value={v.banner_id}
            optionList={dlcBannerImgDropList}
            onChange={handleImgChange}
          />
        </Container>
      ))}
    </>
  );
};

export default DLCLocalForm;

const Container = styled.div`
  margin-bottom: 3.5rem;
`;
